import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MdArrowBack } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from '../LinkButton/LinkButton';
function BackButton({ className, href }) {
    const navigate = useNavigate();
    return (_jsxs(LinkButton, { className: className, onClick: () => (href ? navigate(href) : navigate(-1)), children: [_jsx(MdArrowBack, { className: "h-6 w-6 text-gray-600" }), _jsx("span", { className: "sr-only", children: "Back" })] }));
}
export { BackButton };
//# sourceMappingURL=BackButton.js.map